const AlarmsIndexToName = {
    "4": "BUS Overvoltage Software Interrupt ",
    "5": "Inverter OCP ",
    "7": "BuckBoost Software Overcurrent ",
    "8": "BuckBoost Hardware Overcurrent ",
    "17": "Grid Loss ",
    "18": "High DC Component ",
    "19": "Invalid Grid ",
    "20": "Grid Voltage Imbalance ",
    "21": "Grid Voltage Out of Range ",
    "24": "Grid Frequency Out of Range ",
    "35": "BMS Communication Fault ",
    "36": "BMS Charge Prohibited ",
    "37": "BMS Discharge Prohibited ",
    "38": "Meter Direction Error ",
    "39": "Priority Time Conflict ",
    "40": "BMS Fault or Warning ",
    "65": "Invalid Generator ",
    "66": "Generator Voltage Abnormal ",
    "67": "Generator Frequency Fault ",
    "68": "Generator Voltage Imbalance ",
    "69": "Generator Voltage Loss ",
    "82": "EPS Voltage Fault ",
    "83": "EPS Voltage S Fault ",
    "84": "EPS Voltage T Fault ",
    "85": "Low EPS BUS Voltage ",
    "86": "Load Abnormal ",
    "87": "High Line Voltage ",
    "88": "High DC Voltage ",
    "89": "Battery OCP ",
    "97": "Battery Reverse Polarity ",
    "98": "Battery Disconnected ",
    "99": "Low Battery Voltage ",
    "102": "Battery Soft Start Failed ",
    "103": "High Battery Voltage ",
    "113": "BMS Error ",
    "114": "BMS Communication Fault ",
    "115": "CT Zero-Line Reverse ",
    "116": "Pairing Timeout ",
    "117": "Meter Loss ",
    "118": "Battery Sleep ",
    "119": "Battery NTC Open ",
    "134": "Low PV Voltage ",
    "145": "ARM Receiving Slave DSP Communication Fault ",
    "146": "ARM Receiving Master DSP Communication Fault ",
    "147": "Master DSP Receiving ARM Communication Fault ",
    "148": "Slave DSP Receiving ARM Communication Fault ",
    "149": "Slave DSP Receiving Master DSP Communication Fault ",
    "151": "Master DSP Receiving Slave DSP Communication Fault ",
    "152": "LCD Communication Fault ",
    "161": "Neutral Ground Fault ",
    "162": "Insulation Impedance Abnormal ",
    "163": "Relay Abnormal ",
    "164": "High Bus Voltage Abnormal ",
    "165": "Version Mismatch ",
    "166": "UHCT Fault ",
    "168": "Shutdown ",
    "177": "EPS Output Short Circuit Fault ",
    "178": "Automatic Test Fault ",
    "179": "Initialization Mode Fault ",
    "180": "NTC Open Fault ",
    "181": "AM Heatsink Over Temperature ",
    "182": "Buck-Boost Over Temperature ",
    "183": "BUS Imbalance ",
    "184": "High PV3 Voltage ",
    "193": "High PV1 Voltage ",
    "194": "High PV2 Voltage ",
    "195": "BOOST Over Temperature ",
    "196": "Inverter Over Temperature ",
    "197": "Main Power Inverter System Fault ",
    "198": "Main Power SP System Fault ",
    "199": "High GFCI ",
    "200": "High AFCI ",
    "225": "PV1 Short Circuit ",
    "226": "PV2 Short Circuit ",
    "227": "Fan Fault ",
    "228": "Battery NTC Disconnect Warning ",
    "229": "Soft Start Timeout Warning ",
    "231": "Battery Temperature Out of Range ",
    "232": "Battery Overload Warning ",
    "241": "Battery Full Charge Warning ",
    "242": "Battery Needs Charging Warning ",
    "243": "BMS Warning ",
    "244": "Battery Charge Only Warning ",
    "245": "Battery Low Power Warning ",
    "246": "NTC Open Warning "
}

export default {AlarmsIndexToName};